import { createFileRoute, Outlet } from "@tanstack/react-router";
import { BreadcrumbNav } from "src/components/breadcrumbs/breadcrumbs";
import * as React from "react";

export const Route = createFileRoute("/_breadcrumbs")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className={"container mx-auto px-4"}>
      <BreadcrumbNav />
      <Outlet />
    </div>
  );
}
